import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Components/About/About.css";


import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from "./Components/Header.js";
import HeaderEdit from "./Components/HeaderEdit";


import About2 from "./Components/About2";
import RecrutationLight from "./Components/RecrutationLight";
import Footer from "./Components/Footer";



class App extends React.Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    AOS.init({
      duration : 1000,
    })
  }
  render() {
    return(    <div className="App w-100 mx-auto">
    <HeaderEdit />
    <About2 lang={this.props.lang} />           
    <RecrutationLight lang={this.props.lang} />
    <Footer lang={this.props.lang} />
  </div>)

  };
}

export default App;
